export default __webpack_public_path__ + "static/media/load.91ce00d4.gif";